<template>
  <div class="details">
    <ul>
      <li>
        <p>用户头像</p>
        <div><img :src="info.headImg" alt="" /></div>
      </li>
      <li>
        <p>用户昵称</p>
        <div>{{ info.nickname }}</div>
      </li>
      <li>
        <p>发布标题</p>
        <div>{{ info.title }}</div>
      </li>
      <li>
        <p>发布正文</p>
        <div>
          {{ info.content }}
          <div class="imagebox" v-if="!isVideo">
            <p v-for="(item, index) in mediaList" :key="index">
              <el-image
                style="width: 100%; height: 100%"
                :src="item"
                :preview-src-list="mediaList"
              >
              </el-image>
            </p>
          </div>
          <div v-else class="videobox" @click="videoShow()">
            <video :src="mediaList[0]"></video>
            <p><img src="@/assets/video.png" alt="" /></p>
          </div>
        </div>
      </li>
      <li>
        <p>发布时间</p>
        <div>{{ info.updatedTime }}</div>
      </li>
    </ul>
    <div class="btnbox">
      <el-button class="cancel-btn calloff-btn" @click="goBack">返回</el-button>
    </div>
    <!-- 查看视频 -->
    <el-dialog
      :visible.sync="videoVisible"
      width="45%"
      :before-close="videoClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>查看视频</p>
        <span @click="videoClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="video-box">
        <video :src="mediaList[0]" controls></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCircleDetails } from "@/api/circle";
export default {
  data() {
    return {
      info: {},
      id: this.$route.query.id,
      mediaList: [],
      isVideo: false,
      videoVisible: false,
    };
  },
  async created() {
    const res = await getCircleDetails({ id: this.id });
    this.info = res.result;
    if (res.result.fileUrl.indexOf(".mp4") !== -1) {
      this.isVideo = true;
    } else {
      this.isVideo = false;
    }
    this.mediaList = res.result.fileUrl.split(",");
    // console.log("this.mediaList :>> ", this.mediaList);
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    videoClose() {
      this.videoVisible = false;
    },
    videoShow() {
      this.videoVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  ul {
    li {
      display: flex;
      // align-items: center;
      margin-bottom: 24px;
      > p {
        min-width: 100px;
        font-weight: 400;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
      }
      > div {
        font-weight: 400;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
        word-break: break-all;
        width: 80%;
        img {
          width: 60px;
          height: 60px;
          border-radius: 100%;
        }
      }
      .imagebox {
        display: flex;
        flex-wrap: wrap;
        p {
          width: 104px;
          height: 104px;
          border-radius: 8px;
          margin-right: 8px;
          margin-top: 16px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
      }
      .videobox {
        width: 104px;
        height: 104px;
        margin-top: 16px;
        background: #262626;
        border-radius: 8px;
        position: relative;
        cursor: pointer;
        video {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
        p {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 36px;
            height: 36px;
          }
        }
      }
    }
  }
  .btnbox {
    margin-left: 100px;
  }
  .video-box {
    width: 100%;
    height: 400px;
    background: #000000;
    border-radius: 4px;
    video {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
  }
}
</style>
